/**
 * Card
 */

// Module dependencies
import 'protons';
import 'atoms/image';
import 'atoms/button';

// Module template
import './_card.css';
import './_card.twig';

export const name = 'card';

export function disable() {}
export function enable() {}

export default enable;
